const isResidential = state => state.customerType === 'resi' ? 1 : 0;
const noEmail = state => state.mail === 'noemail@mega.be';
const isTestAchat = state => state.agentCustomId === 'AG000132'; //ER-710
const allowBXResi = state => (state.agentCustomId === 'AG000132' || state.agentCustomId === 'AG000001' || state.agentCustomId === 'AG000054'); //ER-710

const hasSomePersonalDetails = (state) => {
  const data = [
    state.firstName,
    state.lastName,
    state.birthDate,
    state.mail,
    state.phone.number,
    state.coholderFirstName,
    state.coholderLastName
  ];
  return data.some(value => value != null && Boolean(value))
}
export default {
  isResidential,
  hasSomePersonalDetails,
  noEmail,
  isTestAchat,
  allowBXResi
};


// WEBPACK FOOTER //
// ./src/store/modules/subscription/getters.js